import { useParams } from "react-router-dom";
import EnrollmentForm from "@/components/site/EnrollmentForm";
import PageHero from "@/components/site/PageHero";

export default function EnrollPage() {
  const { slug } = useParams();

  return (
    <div data-testid="enroll-page" className="bg-navy">
      <PageHero
        testid="enroll-hero"
        overline="Cohort 04 · Open enrolment"
        lines={[
          <>Request your seat at</>,
          <>
            <em className="italic text-[#C6A87C]">Gurukul of Ramana.</em>
          </>,
        ]}
        sub="Tell us about your background and the programme you're drawn to. A programme advisor will write to you within one business day with cohort dates, prerequisites, and fee structure."
      />
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-20 lg:py-28">
        <EnrollmentForm defaultCourse={slug || ""} />
      </div>
    </div>
  );
}
